var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative c" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("h3", { staticClass: "title" }, [
                _vm._v("蛋糕1 " + _vm._s(_vm.title)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "pageFrom",
                      attrs: {
                        inline: "",
                        size: "small",
                        model: _vm.pageFrom,
                        "label-position": "right",
                        "label-width": "100px",
                      },
                    },
                    [
                      !_vm.ljcType
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "商品来源：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.search },
                                  model: {
                                    value: _vm.pageFrom.source,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.pageFrom, "source", $$v)
                                    },
                                    expression: "pageFrom.source",
                                  },
                                },
                                _vm._l(_vm.FROM_TYPE_OPTIONS, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "蛋糕品牌：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                clearable: "",
                                placeholder: "请选择",
                                filterable: "",
                                "filter-method": _vm.handleAgreementSearch,
                              },
                              on: { change: _vm.search },
                              model: {
                                value: _vm.pageFrom.brandId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "brandId", $$v)
                                },
                                expression: "pageFrom.brandId",
                              },
                            },
                            _vm._l(_vm.brandOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.brandStr, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "蛋糕名称：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "蛋糕名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.pageFrom.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pageFrom, "name", $$v)
                                },
                                expression: "pageFrom.name",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.search },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-btw" }, [
                    _c(
                      "div",
                      { staticClass: "buttons" },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:cake:batchDelete"],
                                expression:
                                  "['admin:customer:cake:batchDelete']",
                              },
                            ],
                            attrs: {
                              type: "primary",
                              disabled: !_vm.ids || !_vm.ids.length,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteBatch("")
                              },
                            },
                          },
                          [_vm._v("批量移除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:cake:export"],
                                expression: "['admin:customer:cake:export']",
                              },
                            ],
                            staticStyle: { "margin-right": "10px" },
                            attrs: { type: "primary" },
                            on: { click: _vm.exportCustomerSku },
                          },
                          [_vm._v("导出结果")]
                        ),
                        _vm._v(" "),
                        _c(
                          "ButtonUploadExcel",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:cake:import:bind"],
                                expression:
                                  "['admin:customer:cake:import:bind']",
                              },
                            ],
                            attrs: {
                              beforeUpload: function (file) {
                                return _vm.beforeUpload(file, "updatePriceApi")
                              },
                            },
                          },
                          [_vm._v("导入更新授权与价格")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div"),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                size: "mini",
                "highlight-current-row": "",
                "max-height": "600",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "蛋糕名称", "min-width": "180" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "brandName",
                  label: "品牌名称",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sourceName",
                  label: "商品来源",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "costPrice",
                  label: "成本价",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "defaultPrice",
                  label: "默认售价",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyPrice",
                  label: "供货价",
                  "min-width": "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "mini" },
                          on: {
                            blur: function ($event) {
                              return _vm.changePrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.supplyPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "supplyPrice", $$v)
                            },
                            expression: "scope.row.supplyPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sellPrice", label: "售价", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "mini" },
                          on: {
                            blur: function ($event) {
                              return _vm.changePrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.sellPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "sellPrice", $$v)
                            },
                            expression: "scope.row.sellPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "展示状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeIsShow(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "50", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:customer:cake:delete"],
                                expression: "['admin:customer:cake:delete']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteBatch(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "10px 0" } },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [15, 30, 45, 60],
                  "page-size": _vm.pageFrom.limit,
                  "current-page": _vm.pageFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SelectPintuan", {
        ref: "SelectPintuanRef",
        on: { doRefresh: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }